/*
 * Modal for Topic Attribute
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "underscore",
  "messaging/messenger",
  "./attributesModalView",
], function (Marionette, Backbone, $, _, Messenger, AttributesModalView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "attributesItem";
      this.region = options.region;
      this.editMode = options.editMode;
      this.model = options.model;
    },
    show: function (attribute) {
      // create backup of attribute in case of revert
      attribute.backup();
      // Model to pass to view, holds attribute, types, editMode
      this.model = new Backbone.Model({});
      this.model.attribute = attribute;
      this.model.editMode = this.editMode;
      const activeKb = Messenger.reqres.request("active:kb");
      this.model.attributeTypes = Messenger.reqres.request("fetch:attributeTypes", activeKb);

      this.model.dataTypes = Messenger.reqres.request("fetch:attribute:dataTypes");

      this.layout = new AttributesModalView.attributesModalLayout({
        model: this.model,
      });

      this.model.attributeTypes.onSynced(function () {
        this.showRegion(this.layout);
      }, this);

      attribute.on(
        "invalid",
        function (model, error) {
          this.layout.clearErrors();
          if ("name" in error) {
            this.layout.nameError(error["name"]);
          }
        },
        this,
      );

      this.layout.on(
        "change:attribute:dataType",
        function () {
          // warn the user of consequences of changing data type of existing attribute
          if (this.model.attribute.get("id") > 0) {
            //changing the attribute data type of existing attribute
            Messenger.okDialog("admin.attributes.attributeDataTypeChangeWarning");
          }
        },
        this,
      );

      this.layout.on(
        "done",
        function () {
          const _this = this;
          attribute.set("name", this.layout.getNameValue());
          attribute.set("attributeTypeId", this.layout.getAttributeType());
          attribute.set("unfilterable", this.layout.getAttributeUnfilterable());
          const dataType = this.layout.getAttributeDataTypeId();
          attribute.set("dataType", dataType);
          if (Messenger.reqres.request("save:textbox")) {
            attribute.saveModel({
              success: function () {
                attribute.dirty = false;
                Messenger.vent.trigger("close:modal");
              },
              error: function (model, response) {
                if (response.status === 400) {
                  if (_this.editMode === true) {
                    Messenger.okDialog(
                      $.t("admin.attributes.updateError", { message: response.responseJSON.value }),
                    );
                  } else {
                    Messenger.okDialog(
                      $.t("admin.attributes.addError", { message: response.responseJSON.value }),
                    );
                  }
                } else {
                  Messenger.showErrorFromResponse(response);
                }
              },
            });
          }
        },
        this,
      );

      this.layout.on(
        "cancel",
        function () {
          attribute.restore();
          if (_.isUndefined(attribute.get("id"))) {
            attribute.deleteModel();
          }
          Messenger.vent.trigger("close:modal");
        },
        this,
      );
    },
  });
});
